export type MarkdownHeadingSize = 'default' | 'small'

export function getMarkdownHeadingClass(headingSize: MarkdownHeadingSize) {
  return headingSize === 'small' ? 'headings-small' : undefined
}
